import React from "react";
import { Card, CardBody } from "reactstrap";

type Props = Readonly<{
  sidebarVisible: boolean;
}>;

export const LoginMessage = ({ sidebarVisible }: Props) => {
  let message = "Login to the workbench using the menu in the top-left.";
  if (sidebarVisible) {
    message = "Login to the workbench.";
  }
  return (
    <div className="d-flex align-items-center h-100 justify-content-center w-100">
      <Card color="secondary">
        <CardBody className="p-4">
          <h1 className="display1 m-0 text-white">{message}</h1>
        </CardBody>
      </Card>
    </div>
  );
};
LoginMessage.displayName = "LoginMessage";
